import { Entity } from '../../../../../game';
import { Vector } from '../../../../../types';
import {
  multiply,
  multiplyScalar,
  repeat,
  add,
  volume,
} from '../../../../../utils';

export class SwarmEntity extends Entity {
  count: Vector = [8, 4, 1];
  position: Vector = [-75, 200, 0];
  startingPosition: Vector = this.position;
  velocity: Vector = [25, -7, 0];
  spacing: Vector = [20, 20, 20];
  size: Vector = multiply(this.count, this.spacing);
  minX: number = -120;
  maxX: number = -this.minX - this.size[0];
  glyphSize: Vector = [10, 5, 10];
  alive: boolean[][][] = repeat(this.count[0], () =>
    repeat(this.count[1], () => new Array(this.count[2]).fill(true)),
  );
  remaining: number = volume(this.count);
  dead: boolean = false;

  step(delta: number) {
    if (this.dead) return;

    this.position = add(this.position, multiplyScalar(this.velocity, delta));
    if (
      (this.position[0] > this.maxX && this.velocity[0] > 0) ||
      (this.position[0] < this.minX && this.velocity[0] < 0)
    ) {
      this.velocity[0] *= -1;
    }
  }

  aliveMax(): Vector {
    let maxX = -1;
    let maxY = -1;
    let maxZ = -1;
    for (let i = 0; i < this.alive.length; i++) {
      const r1 = this.alive[i];
      for (let j = 0; j < r1.length; j++) {
        const r2 = r1[j];
        for (let k = 0; k < r2.length; k++) {
          if (r2[k]) {
            if (i > maxX) maxX = i;
            if (j > maxY) maxY = j;
            if (k > maxZ) maxZ = k;
          }
        }
      }
    }
    return multiply([maxX + 1, maxY + 1, maxZ + 1], this.spacing);
  }

  aliveMin(): Vector {
    let [minX, minY, minZ] = this.count;
    for (let i = 0; i < this.alive.length; i++) {
      const r1 = this.alive[i];
      for (let j = 0; j < r1.length; j++) {
        const r2 = r1[j];
        for (let k = 0; k < r2.length; k++) {
          if (r2[k]) {
            if (i < minX) minX = i;
            if (j < minY) minY = j;
            if (k < minZ) minZ = k;
          }
        }
      }
    }
    return multiply([minX, minY, minZ], this.spacing);
  }

  hit([x, y, z]: Vector): void {
    this.alive[x][y][z] = false;
    this.remaining--;
    if (this.remaining <= 0) this.dead = true;
  }

  randomGlyph(): Vector {
    // get random alive enemy
    const alive: Vector[] = [];
    for (let i = 0; i < this.alive.length; i++) {
      const r1 = this.alive[i];
      for (let j = 0; j < r1.length; j++) {
        const r2 = r1[j];
        for (let k = 0; k < r2.length; k++) {
          if (r2[k]) {
            alive.push([i, j, k]);
          }
        }
      }
    }
    return alive[Math.floor(Math.random() * alive.length)];
  }

  randomPosition(): Vector {
    return add(
      this.position,
      add(multiply(this.randomGlyph(), this.spacing), [5, 0, 0]),
    );
  }
}
